<div class="modal">
  <div class="modal__head">
    <div class="grid-row grid-row--aic">
      <div class="grid-col">
        <div class="h3">Refund Payment</div>
      </div>
      <div class="grid-col grid-col--auto">
        <button type="button" class="modal__close" (click)="onClose()">
          <anduin-icon name="x" aria-hidden="true" height="24" stroke="currentColor" stroke-width="2" width="24" />
        </button>
      </div>
    </div>
  </div>
  <div class="modal__cont">
    <p class="h4">Refund: {{ data.amount | currency: currencyCode }}</p>
    <p class="mt--025">Refunds take 5–10 days to appear on a client’s statement.</p>
    <div class="mt--125 grid-row grid-row--jcb">
      <div class="grid-col grid-col--auto">
        <button type="button" class="button" (click)="onClose()">Close</button>
      </div>
      <div class="grid-col grid-col--auto">
        <button type="button" class="button button--primary" (click)="confirmRefund(data)">Refund</button>
      </div>
    </div>
  </div>
</div>
